<script>import { Button } from "duo-kit"; // just to test sentry errors

function doError() {
  throw new Error("Oh no!");
}</script>
<Button on:click={doError}>Test Errors</Button>